export function BrandLogo() {
  return (
    <img src="/wisdomx-orbis-logo.png" alt="WisdomX ORBIS" className="h-11 w-auto max-w-[200px]" />
  );
}

/** Kept for any direct callers outside the sidebar logo slot. */
export function OrbitalMark({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 56 56" aria-hidden="true">
      <circle cx="28" cy="28" r="24" fill="none" stroke="#3D59AE" strokeOpacity="0.5" />
      <ellipse
        cx="28"
        cy="28"
        rx="24"
        ry="10"
        fill="none"
        stroke="#5773C9"
        strokeOpacity="0.5"
        transform="rotate(-32 28 28)"
      />
      <ellipse
        cx="28"
        cy="28"
        rx="24"
        ry="10"
        fill="none"
        stroke="#5773C9"
        strokeOpacity="0.5"
        transform="rotate(22 28 28)"
      />
      <circle cx="28" cy="28" r="11" fill="url(#brand-logo-core)" />
      <text
        x="28"
        y="29"
        textAnchor="middle"
        dominantBaseline="central"
        className="font-display"
        fontSize="13"
        fontWeight="900"
        fill="#FFFFFF"
      >
        X
      </text>
      <defs>
        <linearGradient id="brand-logo-core" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1A3B8F" />
          <stop offset="100%" stopColor="#0070F3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
